import { toJcamps } from './toJcamps.js';
/**
 * Convert an Analysis to a single JCAMP string (all spectra joined).
 * @param analysis - The analysis to convert
 * @param options - Options for the JCAMP output
 * @returns JCAMP string
 */
export function toJcamp(analysis, options = {}) {
    return toJcamps(analysis, options).join('\n');
}
//# sourceMappingURL=toJcamp.js.map